import React from 'react';
import PropTypes from 'prop-types';
import Link from '@welldev-group/rcl-link';
import Icon from '@welldev-group/rcl-icon';
import './styles.scss';

const TransactionTableItemTitle = ({ lineItemTitle, orderDetailsShowUrl }) => {
  if (!orderDetailsShowUrl) {
    return <span>{lineItemTitle}</span>;
  }

  return (
    <Link
      href={orderDetailsShowUrl}
      modifier="tertiary"
      size="small"
      openNewTab={true}
    >
      <span>{lineItemTitle}</span>
      <Icon
        name="externalLink"
        color="tertiary"
        className="transaction-table-item-title__icon"
      />
    </Link>
  );
};

TransactionTableItemTitle.defaultProps = {
  orderDetailsShowUrl: null,
};

TransactionTableItemTitle.propTypes = {
  lineItemTitle: PropTypes.string.isRequired,
  orderDetailsShowUrl: PropTypes.string,
};

export default TransactionTableItemTitle;
